import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { longIslandConfig } from "./data";

export default function LongIslandPage() {
  return <CityPageTemplate config={longIslandConfig} />;
}